// store.js
import { reactive } from 'vue'

export const store = reactive({
  loggedIn: false,
  pdfData: null,
  logIn() {
    this.loggedIn = true
  },
  logOut() {
    this.loggedIn = false
  }

})